import { render, staticRenderFns } from "./CMSBlogForm.vue?vue&type=template&id=023f814c&"
import script from "./CMSBlogForm.vue?vue&type=script&lang=js&"
export * from "./CMSBlogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports